import {
	observer
} from 'mobx-react';
import {
	toJS
} from 'mobx';
import {
	WeaRadioGroup
} from 'ecCom';

@observer
export default class RadioGroup extends React.Component {
	render() {
		const {
			store
		} = this.props, {
			config,
			handleRadioGroupChange
		} = store;

		return (
			<div className='radio-group'>
				<WeaRadioGroup ecId={`${this && this.props && this.props.ecId || ''}_WeaRadioGroup@9m1mzi`} 
					config={toJS(config)}
					onChange={handleRadioGroupChange}
				/>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/public/valhalla/components/RadioGroup.js